const MAXIMUM_EXPIRATION_YEARS = 1;
const DOMAINS = {
  development: 'development.odin',
  staging: 'qconcursos-hmg.com',
  production: 'qconcursos.com'
};

export default class CookieManager {
  static getCookie(name) {
    return this._getCookie(name);
  }

  static setPersistentCookie(name, value) {
    const expiration = new Date();
    expiration.setFullYear(expiration.getFullYear() + MAXIMUM_EXPIRATION_YEARS);

    this._setCookie(name, value, expiration);
  }

  static setSessionCookie(name, value) {
    this._setCookie(name, value);
  }

  static setExpirationCookie(name, value, days) {
    const expiration = new Date();
    expiration.setDate(expiration.getDate() + days);

    this._setCookie(name, value, expiration);
  }

  static removeCookie(name) {
    this._setCookie(name, null, new Date());
  }

  static _getCookie(name) {
    const prefix = name + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const array = decodedCookie.split(';');

    for (let i = 0; i < array.length; i++) {
      let cookie = array[i];

      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }

      if (cookie.indexOf(prefix) === 0) {
        return cookie.substring(prefix.length, cookie.length);
      }
    }

    return null;
  }

  static _setCookie(name, value, expiration = null) {
    const suffix = expiration ? ` expires=${expiration}` : '';
    document.cookie = `${name}=${value};domain=${DOMAINS[RAILS_ENV]};${suffix}`;
  }
}
